export default {
    estimatedMortgage(state) {
        return state.estimatedMortgage;
    }
};
